import { Map } from 'immutable';

import * as ActionTypes from '../constants/ActionTypes';

import { DEFAULT_TITLE, PageTitles } from '../content/StepContent';
import { NavigationMap } from '../constants/Steps';

const initialState = Map({
    title: DEFAULT_TITLE,
    stepIndex: null,

    canSubmit: false,
    invalidSubmit: false,

    experiment: false,
});

const reducerNavigation = (state = initialState, action) => {
    if (action.type === ActionTypes.NAVIGATION_RESET) {
        if (action.query && action.query.vf_experiment) {
            return state.merge(Map({ experiment: true }));
        }
        return initialState;
    }

    if (action.type === ActionTypes.NAVIGATE) {
        let experiment = false;
        if (action.search && action.search.vf_experiment) {
            experiment = true;
        }

        if (action.url && action.url.length) {
            const stepIndex = NavigationMap[action.url];

            return state.merge(Map({
                title: PageTitles[stepIndex],
                stepIndex,
                invalidSubmit: false,
                experiment,
            }));
        }

        return state.merge(initialState);
    }

    if (action.type === ActionTypes.INVALIDATE_FORM) {
        return state.merge(Map({
            canSubmit: false,
        }));
    }

    if (action.type === ActionTypes.VALIDATE_FORM) {
        return state.merge(Map({
            canSubmit: true,
            invalidSubmit: false,
        }));
    }

    if (action.type === ActionTypes.INVALID_SUBMIT) {
        return state.merge(Map({
            invalidSubmit: true,
        }));
    }

    if (action.type === ActionTypes.VALID_SUBMIT) {
        return state.merge(Map({
            invalidSubmit: false,
        }));
    }

    return state;
};

export default reducerNavigation;



// WEBPACK FOOTER //
// ./src/reducers/navigation.js